export default function sanitize(input) {
    if (typeof input === 'string') {
      return input.replace(/[<>]/g, '');
    }
    return input;
  }